import React from 'react'
import Select from 'react-select'
import styled from 'styled-components'
import * as Utils from '@services/utils'

import {
    SelectBtn,
    FormInputContainer,
    FormInputLabel,
} from '@appearance/styled'
import i18n from '@localization/i18n'

export default ({
    label,
    value,
    onChange,
    onInputChange,
    placeholder,
    options,
    inputHeight = 40,
    width,
    required,
    hideRequiredSign,
}) => {
    const customStyles = {
        control: (provided) => {
            const minHeight = inputHeight
            return { ...provided, minHeight }
        },
    }

    return (
        <FormInputContainer width={width}>
            <FormInputLabel lang={i18n.locale}>
                {label}
                {required && !hideRequiredSign && (
                    <RequiredSign> * </RequiredSign>
                )}
            </FormInputLabel>
            <SelectBtn height={inputHeight}>
                <Select
                    placeholder={placeholder}
                    value={Utils.isEmptyStr(value.value) ? null : value}
                    onChange={onChange}
                    options={options.filter((opt) => opt.value !== '')}
                    height={inputHeight}
                    styles={customStyles}
                    onInputChange={onInputChange}
                />
            </SelectBtn>
        </FormInputContainer>
    )
}

const RequiredSign = styled.span`
    color: red;
`
